const COLOR_SWATCHES = [
  "#ef4444",
  "#f97316",
  "#eab308",
  "#22c55e",
  "#3b82f6",
  "#8b5cf6",
  "#ec4899",
  "#14b8a6",
  "#f8fafc",
  "#94a3b8",
  "#475569",
  "#0f172a",
];

export default COLOR_SWATCHES;
